import { createContext, useContext } from 'react';

export interface MinimizedDrawerItem {
  id: string;
  title: string;
  data?: any;
}

export interface MinimizedDrawersContextType {
  minimizedDrawers: MinimizedDrawerItem[];
  minimizeDrawer: (id: string, title: string, data?: any) => void;
  restoreDrawer: (id: string) => void;
  isMinimized: (id: string) => boolean;
  lastRestoredItem: MinimizedDrawerItem | null;
  clearLastRestoredItem: () => void;
  clearMinimizedDrawer: (id: string) => void;
}

export const MinimizedDrawersContext = createContext<
  MinimizedDrawersContextType | undefined
>(undefined);

export const useMinimizedDrawers = () => {
  const context = useContext(MinimizedDrawersContext);
  if (context === undefined) {
    throw new Error(
      'useMinimizedDrawers must be used within a MinimizedDrawersProvider',
    );
  }
  return context;
};
